import { TextField, MenuItem } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { styled } from "@mui/material/styles";
import { IOption } from "../../interfaces/Utils";
import { FC } from "react";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#CCC",
    },
    "&:hover fieldset": {
      borderColor: "#0063cc",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
});

interface IDropDown {
  name: string;
  options: IOption[];
}

const DropDown: FC<IDropDown> = ({ name, options, ...otherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (evt: any) => {
    const { value } = evt.target;
    setFieldValue(name, value.value);
  };

  const configSelect = {
    ...field,
    ...otherProps,
    select: true,
    fullWidth: true,
    onChange: handleChange,
    helperText: "",
    value:
      options && field.value !== ""
        ? options.find((option: IOption) => option.value === field.value)
        : field.value,
  };

  if (meta && meta.touched && meta.error) {
    configSelect.helperText = meta.error;
  }

  return (
    <CssTextField
      variant="outlined"
      {...configSelect}
      error={Boolean(meta.error)}
    >
      {options.map((item, index) => (
        <MenuItem key={index} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </CssTextField>
  );
};

export default DropDown;
